import type { ReactNode } from 'react';

export const symbol_garage_home: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M498.91-822q8.92 3 17.09 9l260 195q11.25 8.25 17.63 21 6.37 12.75 6.37 27v420q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63-12.82 0-21.32-8.63-8.5-8.62-8.5-21.37v-420L480-765 220-570v420q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63-12.82 0-21.32-8.63-8.5-8.62-8.5-21.37v-420q0-14.25 6.38-27 6.37-12.75 17.62-21l260-195q8.3-6 17.34-9 9.05-3 18.86-3 9.8 0 18.71 3ZM340-180h280v-110H340v110Zm0-170h280v-110H340v110Zm-30 230q-12.75 0-21.37-8.63Q280-137.25 280-150v-340q0-12.75 8.63-21.38Q297.25-520 310-520h340q12.75 0 21.38 8.62Q680-502.75 680-490v340q0 12.75-8.62 21.37Q662.75-120 650-120H310Z"
		/>
	</svg>
);
